<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <defs>
  </defs>
  <path class="cls-4" d="m47.09,67.16c-.33,0-.64-.16-.83-.44l-22.1-32.63-14.04,10.26c-.45.33-1.07.23-1.4-.22s-.23-1.07.22-1.4l14.88-10.87c.22-.16.49-.22.76-.18.27.05.5.2.66.42l21.75,32.11,21.62-40.33c.16-.3.47-.5.81-.52.34-.02.67.12.88.4l5.75,7.69c.33.44.24,1.07-.2,1.4-.44.33-1.07.24-1.4-.2l-4.81-6.43-21.66,40.4c-.17.31-.48.51-.83.53-.02,0-.03,0-.05,0Z"/>
  <path class="cls-3" d="m9.53,69.73c-.26,0-.51-.1-.71-.29-.39-.39-.39-1.02,0-1.41l14.2-14.2c.33-.33.86-.39,1.25-.13l10.11,6.61,19.48-23.4c.18-.21.43-.34.7-.36.28-.02.54.08.75.27l11.16,10.37,8.3-4.4c.49-.26,1.09-.07,1.35.42.26.49.07,1.09-.41,1.35l-8.92,4.73c-.38.2-.84.14-1.15-.15l-10.9-10.14-19.37,23.27c-.32.39-.89.48-1.32.2l-10.18-6.65-13.63,13.62c-.2.2-.45.29-.71.29Z"/>
  <circle class="cls-1" cx="34.67" cy="61.09" r="2.63"/>
  <circle class="cls-1" cx="54.83" cy="38.79" r="2.63"/>
  <circle class="cls-1" cx="66.86" cy="48.05" r="2.63"/>
  <circle class="cls-1" cx="23.85" cy="55.5" r="2.63"/>
  <circle class="cls-1" cx="76.11" cy="42.95" r="2.63"/>
  <circle class="cls-3" cx="24.34" cy="33.09" r="2.63"/>
  <circle class="cls-3" cx="47.09" cy="66.16" r="2.63"/>
  <circle class="cls-3" cx="76.11" cy="33.09" r="2.63"/>
  <circle class="cls-3" cx="70" cy="24.87" r="2.63"/>
  <path class="cls-2" d="m80.55,74.11H9.45c-.78,0-1.42-.67-1.42-1.5V17.39c0-.83.64-1.5,1.42-1.5s1.42.67,1.42,1.5v53.72h69.67c.78,0,1.42.67,1.42,1.5s-.64,1.5-1.42,1.5Z"/>
</svg>
</template>

<script>
export default {
    name: "CombinedMetricsTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0b5e73;
  }
  .cls-2 {
    fill: #0c5f74;
  }
  .cls-3 {
    fill: #59c5c7;
  }
  .cls-4 {
    fill: #b9e1d2;
  }
</style>